import React from "react";
import { logoImg, personIcon, logoutIcon } from "../../constants/Images";
import { NavLink } from "reactstrap";
import { Link } from "react-router-dom";
import { doLogout } from "../../redux/actions/authAction";
import { useDispatch, useSelector } from "react-redux";

export default function Topnav() {
  const {profileData} = useSelector(state => state.authData);
  const {name} = profileData || {}
  const dispatch = useDispatch();
  const handleLogout = () => {
    dispatch(doLogout());
  }
  return (
    <div className="admin-header">
      <div className="row">
        <div className="col-6">
          <Link to="/">
            <img src={logoImg} alt="logo" />
          </Link>
        </div>
        <div className="col-6 text-right">
          <div>
            <Link to="/" className="topnavLink">
              <img src={personIcon} alt="User" />
              {name}
            </Link>
            <Link to="/login" className="topnavLink" onClick={handleLogout}>
              <img src={logoutIcon} alt="Logout" />
              Logout
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
